import { createI18n, Locale } from 'vue-i18n';
import nl from '@/locales/nl-NL.json';
import en from '@/locales/en-US.json';
import de from '@/locales/de-DE.json';
import fr from '@/locales/fr-FR.json';
import fi from '@/locales/fi-FI.json';

type MessageSchema = typeof en;
const Locales = ['en-US', 'nl-NL', 'de-DE', 'fr-FR', 'fi-FI'] as const;

const detectLanguage = (): Locale => {
  const userLocale = navigator.language;
  if (!userLocale) {
    return 'en-US';
  }
  const availableLocales = Object.values(Locales) as string[];
  if (availableLocales.includes(userLocale)) {
    return userLocale;
  }

  const shortenedLocale = availableLocales.find(
    (locale) =>
      locale.slice(0, 2).toLocaleLowerCase() ===
      userLocale.slice(0, 2).toLocaleLowerCase(),
  );
  return shortenedLocale ?? 'en-US';
};

export default createI18n<[MessageSchema], (typeof Locales)[number]>({
  legacy: false,
  globalInjection: true,
  locale: detectLanguage(),
  fallbackLocale: 'en-US',
  warnHtmlInMessage: 'off',
  messages: {
    'en-US': en,
    'nl-NL': nl,
    'de-DE': de,
    'fr-FR': fr,
    'fi-FI': fi,
  },
});
